angular.module('property-price-list')
    .component('propertyPriceListBtnOptions', {
        bindings: {
            item: '<',
            largeButton: '<?'
        },
        templateUrl: 'app/property-price-list/_btn-options.html',
        controller: function (PropertyPriceListService) {
            this.PropertyPriceListService = PropertyPriceListService;

            this.canAccept = item => item.status === "DRAFT"
            this.canImplement = item => item.status === "ACCEPTED"
            this.isImplemented = item => item.status === "IMPLEMENTED"
        }
    })
